import { Box, Grid } from '@mui/material'

import classes from './index.styles'

interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...rest } = props

  return (
    <Grid size={12} role="tabpanel" hidden={value !== index} {...rest} sx={classes.tabPanel}>
      <Box sx={classes.customTabPanelContent}>{children}</Box>
    </Grid>
  )
}

export default TabPanel
